module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ecf8aab29858b1233a5214116e8da517.png";